// Arreglo para mantener las definiciones de las rutas
const helpRoutes = [
  { path: "guias", name: "Guias", component: "Guias" },
  { path: "faq", name: "FAQ", component: "FAQ" },
  { path: "videotutorial", name: "VideoTutorial", component: "VideoTutorial" },
	{ path: "acerca-de", name: "AcercaDe", component: "AcercaDe" },
];

// Genera dinámicamente las rutas a partir de las definiciones
const routes = helpRoutes.map(({ path, name, component }) => ({
  path: `/${path}`,
  name,
  // Importación dinámica para lograr la carga diferida de componentes de ruta
  component: () => import(`../views/ayuda/${component}.vue`),
}));

export default routes;
